module.exports = __webpack_public_path__ + "static/media/size-30.d35d776e.jpg";